import { Component, Inject, NgZone, ChangeDetectorRef } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material';
import { AdminService } from 'src/app/services/admin.service';
import { GoogleServices } from 'src/app/services/google-service';
import { Utils } from 'src/app/services/utils';
import { AssignReviewDialog } from '../../dialogs/assign-review/assign-review';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-review-actions',
    templateUrl: './review-actions.component.html',
    styleUrls: ['./review-actions.component.scss']
})
export class ReviewActionsBottomSheetComponent {
    public review: any;
    public review_status: any;

    constructor(
        private _bottomSheetRef: MatBottomSheetRef<ReviewActionsBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        private _admin: AdminService,
        private _google: GoogleServices,
        private _utils: Utils,
        private dialog: MatDialog,
        private zone: NgZone,
        private cdr: ChangeDetectorRef
    ) {
        this.review = data.review;
        this.review_status = _utils.review_status;
    }

    // Variables para la asignación de la reseña a un usuario específico
    public showAssignForm = false;
    public userIdInput = new FormControl('', [Validators.required, Validators.pattern(/^\d+$/)]);
    public checkingUserAvailability = false;
    public userCanPublish = false;
    public checkedUserId: string = '';
    public assigningReview = false;
    // Nuevas variables para manejar cuentas disponibles
    public availableAccounts: any[] = [];
    public selectedAccountId: string = '';

    // Función original de asignar reseña (ya completada) a un usuario
    assignReview() {
        this._bottomSheetRef.dismiss();

        const dialogRef = this.dialog.open(AssignReviewDialog, {
            width: 'auto',
            data: { review: this.review }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.review) {
                this._bottomSheetRef.dismiss(true);
            }
        });
    }

    // Función para comprobar disponibilidad de usuarios
    checkUserAvailability() {
        const loadingSnackbar = this._utils.showInfo('Buscando usuarios disponibles, esto puede tardar hasta un minuto...', 60000);

        this.review.loadingAvailable = true;

        this._admin.getAvailablePublishers(this.review._id).toPromise()
            .then((response: any) => {
                loadingSnackbar.dismiss();
                this.review.loadingAvailable = false;

                this._utils.showInfo(`Cuentas disponibles para RW#${this.review._id} = ${response['available']}`, 60000);
                this._bottomSheetRef.dismiss(true);
            })
            .catch(error => {
                loadingSnackbar.dismiss();
                this.review.loadingAvailable = false;

                console.log(error);
                this._utils.showError('Error al comprobar disponibilidad', 3000);
                this._bottomSheetRef.dismiss(false);
            });
    }

    // Función para notificar a usuarios disponibles
    notifyAvailableUsers() {
        this._admin.notifySingleRW(this.review._id).toPromise()
            .then((response: any) => {
                const notified = response['notified'];
                const available = response['available'];
                this._utils.showSuccess(`Reseña notificada a ${notified} usuarios de ${available} disponibles`, 5000);
                this._bottomSheetRef.dismiss(true);
            })
            .catch(error => {
                console.log(error);
                this._utils.showError("Error al notificar reseña", 3000);
                this._bottomSheetRef.dismiss(false);
            });
    }

    // Función para mostrar el formulario de asignación
    assignToUserToComplete() {
        this.showAssignForm = true;
        this.userCanPublish = false;
        this.userIdInput.reset();
    }

    // Función para comprobar si un usuario específico puede publicar la reseña
    checkSpecificUserAvailability() {
        if (this.userIdInput.invalid) {
            return;
        }

        const userId = this.userIdInput.value;
        this.checkedUserId = userId;
        this.checkingUserAvailability = true;
        this.availableAccounts = []; // Resetear cuentas disponibles
        this.selectedAccountId = ''; // Resetear cuenta seleccionada
        
        // Force change detection to ensure spinner appears
        this.cdr.detectChanges();

        // Llamada al API para comprobar si el usuario puede publicar la reseña
        this._admin.checkSpecificUserForReview(this.review._id, userId)
        .then((response: any) => {
            // Run inside Angular zone to ensure change detection
            this.zone.run(() => {
                this.checkingUserAvailability = false;
                this.userCanPublish = response && response.available;
                
                // Almacenar las cuentas disponibles si existen
                if (response && response.accounts && response.accounts.length > 0) {
                    this.availableAccounts = response.accounts;
                    // Preseleccionar la primera cuenta por defecto
                    this.selectedAccountId = this.availableAccounts[0]._id;
                }
                
                // Force change detection update
                this.cdr.detectChanges();
            });
        })
        .catch(error => {
            this.zone.run(() => {
                this.checkingUserAvailability = false;
                console.log(error);
                this._utils.showError('Error al comprobar disponibilidad del usuario', 3000);
                this.cdr.detectChanges();
            });
        });
    }

    // Función para asignar la reseña al usuario seleccionado
    assignReviewToUser() {
        if (!this.userCanPublish || !this.checkedUserId || !this.selectedAccountId) {
            return;
        }

        this.assigningReview = true;

        // Llamada al API para asignar la reseña al usuario y cuenta específica
        this._admin.assignReviewToUser(this.review._id, this.selectedAccountId)
            .then(response => {
                this.assigningReview = false;
                this._utils.showSuccess(`Reseña asignada correctamente al usuario #${this.checkedUserId} (cuenta: ${this.selectedAccountId})`, 5000);
                this._bottomSheetRef.dismiss(true);
            })
            .catch(error => {
                this.assigningReview = false;
                console.log(error);
                this._utils.showError('Error al asignar la reseña', 3000);
            });
    }

    // Función para cancelar la asignación y ocultar el formulario
    cancelAssignment() {
        this.showAssignForm = false;
        this.userCanPublish = false;
        this.userIdInput.reset();
    }

    closeSheet(): void {
        this._bottomSheetRef.dismiss();
    }
}